import { encodingForModel, TiktokenModel } from "js-tiktoken";

export function calculateOpenAiUsage(
  model: TiktokenModel,
  messages: unknown[],
  response: string
) {
  const enc = encodingForModel(model as TiktokenModel);

  const prompt_token_quantity = enc.encode(
    JSON.stringify(messages).slice(2, -2).replace(/},{/g, "")
  ).length;
  const completion_token_quantity = enc.encode(response).length;

  return {
    prompt_token_quantity,
    completion_token_quantity,
  };
}
